import React from 'react'

import { ANGLE_MAP } from '@ui/icons/utils/icon-direction'
import { withDirectionalStatics } from '@ui/icons/utils/withDirectionalStatics'

export const SortIcon = withDirectionalStatics((props) => {
  const { size, color, direction = 'up' } = props
  const rotation = ANGLE_MAP[direction] ?? 0

  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g transform={`rotate(${rotation} 6 6)`}>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M2.05568 7.6657C1.9314 7.79425 2.02872 8 2.21379 8L9.7862 8C9.97128 8 10.0686 7.79425 9.94432 7.6657L6.68361 4.29289C6.30606 3.90237 5.69394 3.90237 5.31639 4.29289L2.05568 7.6657Z'
          fill={color}
        />
      </g>
    </svg>
  )
})
